// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__dVU5M","list":"styles_list__2981f"};